<template>
<div :style="cssProps">
    <div class="logo-title d-flex flex-row justify-content-between align-items-center">
      <div>
        <img :src="info.logo ? info.logo : '../assets/images/sg_logo.svg'" @click="$router.push({name:'startPage'})">
        <div class="d-flex flex-column logo-col" style="padding-left:15px;">
          <h1 class="titleTop">Burger & Fries</h1>
          <h2 class="subTitleTop">Search or View Nearby Restaurants Below.</h2>
        </div>
      </div>
      <div>
        <button class="signIn d-flex align-items-center justify-content-around">
          <i class="fal fa-user-circle"></i>
          <span>Account</span>
        </button>
      </div>
  
    </div>
    <div class="allin">
      <alert ref="alert"></alert>
    <div class="main-content d-flex flex-row justify-content-center align-items-center">
        <i class="fal fa-long-arrow-alt-left" @click="$router.go(-1)"></i>
        <div class="d-flex flex-column">
        <h1 class="title">WELCOME</h1>
        <h2 class="subTitle">Let's setup your personal account.</h2>
      
        </div>
      
    </div>
   
    <div class="col-input d-flex flex-column justify-content-center align-items-center">
     <h1>Please fill in all fields below to continue</h1>
     <div class="column d-flex flex-column align-items-center justify-content-around" >
         <input type="text" placeholder="First Name" name="firstname" v-model="user.firstname" v-validate="'required|max:36'">
         <span class="not-work">{{ errors.first('firstname') }}</span>
         <input type="text" placeholder="Last Name" name="lastname" v-model="user.lastname" v-validate="'required|max:36'">
         <span class="not-work">{{ errors.first('lastname') }}</span>
         <input type="text" placeholder="EMAIL" name="emailaddress" v-model="user.emailaddress" v-validate="'required|email|max:128'">
         <span class="not-work">{{ errors.first('emailaddress') }}</span>
         <input type="text" placeholder="Phone Number" name="contactnumber" v-model="user.contactnumber" v-validate="'required'">
         <span class="not-work">{{ errors.first('contactnumber') }}</span>
         <input type="password" placeholder="Password" name="password" v-model="user.password" v-validate="'required|min:7|max:1024'" ref="password">
         <span class="not-work">{{ errors.first('password') }}</span>
         <input type="password" placeholder="Confirm Password" name="confirmpassword" v-model="confirmpassword" v-validate="'required|confirmed:password'" data-vv-as="password">
         <span class="not-work">{{ errors.first('confirmpassword') }}</span>
        <div class="check d-flex flex-row align-items-center">

            <i class="fal" :class="check?'fa-check-circle':'fa-circle'" @click="checkIcon"></i>
            <span>I agree to Seven Girls’ <a href="#">terms of use</a> and <a href="#">privacy policy</a>.</span>
        </div>
        <button class="last-btn" @click="submit">
            <span>Create an Account</span>
        </button>
     </div>
    </div>
    
   </div>
    
</div>
   
</template>
<script>
import {mapState} from "vuex";
import axios from 'axios';
import alert from '../steps/custom/alert.vue'
export default {
    name: 'Signup',
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      alert
    },
    data() {
      return {
        user: {
          firstname: null,
          lastname: null,
          emailaddress: null,
          password: null,
          contactnumber: null
        },
        confirmpassword: null,
        check:false
      };
    },
    computed:{
        ...mapState(["info"]),
        cssProps() { return {
            '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
          }
        },
    },
    methods:{
        checkIcon()
        {
            this.check = !this.check;
            console.log(this.check)
        },
        async submit(){
          let thisRef = this;
          const checking = await this.$validator.validateAll();
          console.log(checking)
          if(checking){
            axios.post("https://secure-badlands-41449.herokuapp.com/users/create?includePrivate=false&key=SPn4GGKDfK4ubhbWD0GbiHofFQwk7INP", this.user)
            .then(response => {
              console.log(response.data);
              thisRef.$store.commit('user.set', {user: response.data});
              this.$router.push({name:'signin'});
            }).catch(error => {
              console.log(error.response.data.message);
              console.log(thisRef.$refs.alert)
              thisRef.$refs.alert.message = error.response.data.message;
              thisRef.$refs.alert.show();
            })
          }
        }
    },
    created(){
      if(this.info.user.emailaddress){
        this.user.emailaddress = this.info.user.emailaddress;
      }
    }
}
</script>
<style scoped>
.not-work{
    
	height: 24px;
width: 240px;
border-radius: 4px;
/* background-color:var(--main-color); */
color: var(--main-color);
font-family: Poppins;
font-size: 10px;
font-weight: 400;
line-height: 16px;
word-spacing:1.2px;
position: relative;
top: 10px;
text-align: center;

}
.last-btn
{
  margin-top: 32px;
	height: 48px;
	width: 360px;
	border-radius: 24px;
	background-color: var(--main-color);
  margin-bottom: 76px;
}
.last-btn span{
  
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;
}

.allin
{
    position: absolute;
    margin: auto;
    top:80px;
    left: 0;
    bottom: 0;
    right: 10%;
}
.check{
    padding-top: 24px;
}
.check i{
  
	color:  var(--main-color);
	font-family: "Font Awesome 5 Pro";
	font-size: 26px;
	line-height: 14px;
	text-align: left;
    padding-right: 20px;
    
}
.check span{
  
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 11px;
	font-weight: 500;
	line-height: 17px;

}
.check span a{
  color: var(--main-color);
  text-decoration: underline;

}
.column
{   
    
    padding-top: 16px;
    padding-left: 10.5%;
}
.column input{
 
  border: none;
  outline: none;
  background-color: rgba(255,255,255,0);
  box-shadow: 0 1px 0 0 rgba(0,0,0,0.2);
  height: 56px;
  width: 350px;
  padding: 18px 5px;
  margin-top: 10px;
}
.column input::placeholder
{
  
	opacity: 0.3;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.col-input h1{
    
	
	width: 205px;
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
    white-space: nowrap;
    text-align: left;

}
.col-input{
    width: 100%;
    padding-top: 48px;
}

.main-content
{
    width: 100%;
    padding-top: 47px;
}
.main-content i 
{
   
	opacity: 0.6;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 32px;
	font-weight: 300;
	line-height: 32px;
    padding-right: 48px;

}
.title {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 24px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 35px;
  color: #000000;
  text-align: left;

}
.subTitle {
  font-family: "Poppins", sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  line-height: 20px;
  color: #000000;
  text-align: left;
  white-space: nowrap
}
button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.titleTop {
  font-family: "Poppins", sans-serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  opacity: 0.8;
  line-height: 26px;
  color: #000000;
  text-align: left;
}
.subTitleTop {
  font-family: "Poppins", sans-serif;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  opacity: 0.4;
  /* line-height: 20px; */
  color: #000000;
  text-align: left;
}
.signIn {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 13px;
  color: #000000;
}
.signIn i {
  height: 21px;
  width: 20px;
  opacity: 0.8;
  color: #000000;
  font-family: "Font Awesome 5 Pro";
  font-size: 20px;
  font-weight: 300;
  line-height: 21px;
}
.signIn span {
  margin-left: 10px;
}
.logo-title {
  padding: 15px 25px;
  border: 1.5px solid rgba(0, 0, 0, 0.05);
}

.logo-title img {
  width: 50px;
  height: 50px;
  float: left;
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Register/Signup.vue